import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type ImageSection } from '../../../types'

const funnelBuilderQueue = useBuilder('emailBuilder')

const ImageCommands = {
  updateBlock: funnelBuilderQueue.createBlockCommand<ImageSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { ImageCommands }
